import React, { ReactNode, useState } from "react";
import styles from "./VerificationInput.module.css";
import { JokerButton, ButtonType } from "material-ui-jokerpro";
import PinInput, { PinInputState } from "../../../components/PinInput";
import { ResendButton } from "../../../components/ResendButton";
import AssetsPack from "../../../util/AssetsPack.js";
import ErrorText from "../../../components/ErrorText";

type VerificationCodeFormProps = {
  onResend: () => void;
  onCancel: () => void;
  onSubmit: (pin: string) => void;
  pinInputState: PinInputState;
  setPinInputState: (state: PinInputState) => void;
  titleComponent?: ReactNode;
  descriptionComponent?: ReactNode;
  errorMessage?: string;
};

const VerificationCodeForm: React.FC<VerificationCodeFormProps> = ({
  onResend,
  onCancel,
  onSubmit,
  pinInputState,
  setPinInputState,
  titleComponent,
  descriptionComponent,
  errorMessage = undefined,
}) => {
  const [pin, setPin] = useState("");
  const [continueDisabled, setContinueDisabled] = useState(true);

  const handlePinChange = (value: string) => {
    setPin(value);
    setPinInputState(PinInputState.default);
    setContinueDisabled(value.length !== 4);
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(pin);
  };

  return (
    <form className={styles["verify-email-form"]}>
      {titleComponent}
      {descriptionComponent}
      <div className={styles["verification-code-wrapper"]}>
        <PinInput onPinChange={handlePinChange} state={pinInputState} />
      </div>
      {errorMessage && (
        <div className={styles["error-wrapper"]}>
          <ErrorText>{errorMessage}</ErrorText>
        </div>
      )}
      <ResendButton onClick={onResend} />
      <div className={styles["button-group"]}>
        <div className="cancel-button-wrapper">
          <JokerButton
            text="Cancel"
            onClick={onCancel}
            type={ButtonType.Text}
            icon={AssetsPack.icons.ICON_CLOSE.default}
            equal
          />
        </div>
        <JokerButton
          text="Continue"
          disabled={continueDisabled}
          type={ButtonType.CTA}
          icon={AssetsPack.icons.ICON_GO.default}
          equal
          animated
          onClick={handleFormSubmit}
        />
      </div>
    </form>
  );
};

export default VerificationCodeForm;
